<template>
  <div>
    <InputMask
      v-model="localDate"
      v-bind="{ id, disabled, placeholder, readonly }"
      :invalid="invalid || !!dateError"
      mask="99.99.9999"
      slotChar="дд.мм.гггг"
      :autoClear="false"
      @blur="handleBlur"
      @focus="emits('focus', $event)"
    />

    <small
      v-if="dateError && !hideError"
      class="text-red-600 block"
    >
      {{ dateError }}
    </small>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { InputProps, InputEmits, validateIsoDate } from '@/shared';
import InputMask from 'primevue/inputmask';

const props = defineProps<InputProps>();
const emits = defineEmits<InputEmits>();

const model = defineModel<string | null>();

const localDate = ref<string | null>();
const dateError = ref<string | null>(null);

const validateDate = (date: string) => {
  const [day, month, year] = date.split('.');

  return validateIsoDate(`${year}-${month}-${day}`, { noFutureDate: props.noFutureDate });
};

const handleBlur = (event: Event) => {
  if (localDate.value) {
    dateError.value = validateDate(localDate.value);
  }

  emits('blur', event);
};

watch(
  model,
  date => {
    if (date) {
      const [year, month, day] = date.split('-');
      localDate.value = `${day}.${month}.${year}`;
    } else {
      localDate.value = '';
      dateError.value = null;
    }
  },
  { immediate: true }
);

watch(localDate, date => {
  if (!date) {
    model.value = null;
    dateError.value = null;
    return;
  }

  const [day, month, year] = date.split('.');
  model.value = `${year}-${month}-${day}`;
});
</script>
